import i18n from '@/Plugins/i18n.js';

const t = (key) =>
  i18n.global.t(`header_analysis.partials.antispam_tags.${key}`);

const AntispamMapper = {
  BCL: {
    get description() {
      return t('bcl.description');
    },
    parse(value) {
      const level = parseInt(value, 10);

      if (isNaN(level)) {
        return '';
      }

      if (level >= 8) {
        return t('bcl.high_complaints');
      }
      if (level >= 4) {
        return t('bcl.mixed_complaints');
      }
      if (level >= 1) {
        return t('bcl.few_complaints');
      }
      return t('bcl.not_bulk');
    }
  },

  ARA: {
    get description() {
      return t('ara.description');
    },
    parse() {
      return '';
    }
  },

  ARC: {
    get description() {
      return t('arc.description');
    },
    parse(value) {
      const mappings = {
        AAR: t('arc.aar'),
        AMS: t('arc.ams'),
        AS: t('arc.as')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  CAT: {
    get description() {
      return t('cat.description');
    },
    parse(value) {
      const mappings = {
        AMP: t('cat.amp'),
        BULK: t('cat.bulk'),
        DIMP: t('cat.dimp'),
        FTBP: t('cat.ftbp'),
        GIMP: t('cat.gimp'),
        HPHSH: t('cat.hphsh'),
        HPHISH: t('cat.hphish'),
        HSPM: t('cat.hspm'),
        INTOS: t('cat.intos'),
        MALW: t('cat.malw'),
        OSPM: t('cat.ospm'),
        PHSH: t('cat.phsh'),
        SAP: t('cat.sap'),
        SPM: t('cat.spm'),
        SPOOF: t('cat.spoof'),
        UIMP: t('cat.uimp'),
        NONE: t('cat.none')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  CIP: {
    get description() {
      return t('cip.description');
    },
    parse() {
      return '';
    }
  },

  CTRY: {
    get description() {
      return t('ctry.description');
    },
    parse() {
      return '';
    }
  },

  DIR: {
    get description() {
      return t('dir.description');
    },
    parse(value) {
      const mappings = {
        INB: t('dir.inb'),
        OUT: t('dir.out'),
        INT: t('dir.int')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  H: {
    get description() {
      return t('h.description');
    },
    parse() {
      return '';
    }
  },

  IPV: {
    get description() {
      return t('ipv.description');
    },
    parse(value) {
      const mappings = {
        CAL: t('ipv.cal'),
        NLI: t('ipv.nli')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  LANG: {
    get description() {
      return t('lang.description');
    },
    parse() {
      return '';
    }
  },

  PTR: {
    get description() {
      return t('ptr.description');
    },
    parse() {
      return '';
    }
  },

  SCL: {
    get description() {
      return t('scl.description');
    },
    parse(value) {
      const level = parseInt(value, 10);

      if (isNaN(level)) {
        return '';
      }

      if (level >= 7) {
        return t('scl.high_confidence');
      }
      if (level >= 5) {
        return t('scl.spam');
      }
      if (level >= 0) {
        return t('scl.not_spam');
      }
      return t('scl.skipped');
    }
  },

  SFTY: {
    get description() {
      return t('sfty.description');
    },
    parse(value) {
      const mappings = {
        9.19: t('sfty.domain_impersonation'),
        '9.20': t('sfty.user_impersonation'),
        9.25: t('sfty.first_contact')
      };
      return mappings[value.toUpperCase()] || t('sfty.identified_phishing');
    }
  },

  SFV: {
    get description() {
      return t('sfv.description');
    },
    parse(value) {
      const mappings = {
        BLK: t('sfv.blk'),
        NSPM: t('sfv.nspm'),
        SFE: t('sfv.sfe'),
        SKA: t('sfv.ska'),
        SKB: t('sfv.skb'),
        SKN: t('sfv.skn'),
        SKQ: t('sfv.skq'),
        SKS: t('sfv.sks'),
        SPM: t('sfv.spm')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  SRV: {
    get description() {
      return t('srv.description');
    },
    parse(value) {
      const mappings = {
        BULK: t('srv.bulk')
      };
      return mappings[value.toUpperCase()] || '';
    }
  },

  SFS: {
    get description() {
      return t('sfs.description');
    },
    parse() {
      return '';
    }
  }
};

function mapAntispamHeader(header, value) {
  const parser = AntispamMapper[header.toUpperCase()];

  if (!parser) {
    return {
      field: header,
      description: '',
      value: value,
      explanation: ''
    };
  }

  return {
    field: header,
    description: parser.description,
    value: value,
    explanation: parser.parse(value)
  };
}

export { AntispamMapper, mapAntispamHeader };
export default AntispamMapper;
